export type BulkVolunteerStatus = "success" | "failed" | "pending";

export interface BulkVolunteer {
  date: string;
  shortId: string;
  name: string;
  location: string;
  dept: string;
  email: string;
  transport: string;
  userId: number;
  registeredStatus: string;
}

export const bulkVolunteerMockData: BulkVolunteer[] = [
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGNE",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 1
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "VERAMAN",
    name: "Venkata Ramanareddy",
    location: "Pune",
    dept: "ITH/IF",
    transport: "Yes",
    registeredStatus: "No",
    email: "capgemini.ramanareddy@mercedes-benz.com",
    userId: 2
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGN1",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 3
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "VERAMA1",
    name: "Venkata Ramanareddy",
    location: "Pune",
    dept: "ITH/IF",
    transport: "Yes",
    registeredStatus: "No",
    email: "capgemini.ramanareddy@mercedes-benz.com",
    userId: 4
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGN2",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 5
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "VERAMA2",
    name: "Venkata Ramanareddy",
    location: "Pune",
    dept: "ITH/IF",
    transport: "Yes",
    registeredStatus: "No",
    email: "capgemini.ramanareddy@mercedes-benz.com",
    userId: 6
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGN3",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 7
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "VERAMA3",
    name: "Venkata Ramanareddy",
    location: "Pune",
    dept: "ITH/IF",
    transport: "Yes",
    registeredStatus: "No",
    email: "capgemini.ramanareddy@mercedes-benz.com",
    userId: 8
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGN4",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 9
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "VERAMA4",
    name: "Venkata Ramanareddy",
    location: "Pune",
    dept: "ITH/IF",
    transport: "Yes",
    registeredStatus: "No",
    email: "capgemini.ramanareddy@mercedes-benz.com",
    userId: 10
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGN5",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 11
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "VERAMA5",
    name: "Venkata Ramanareddy",
    location: "Pune",
    dept: "ITH/IF",
    transport: "Yes",
    registeredStatus: "No",
    email: "capgemini.ramanareddy@mercedes-benz.com",
    userId: 12
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGN6",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 13
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "VERAMA6",
    name: "Venkata Ramanareddy",
    location: "Pune",
    dept: "ITH/IF",
    transport: "Yes",
    registeredStatus: "No",
    email: "capgemini.ramanareddy@mercedes-benz.com",
    userId: 14
  },
  {
    date: "07 May,2026 11:55 AM",
    shortId: "GOVIGN7",
    name: "Govindh Vignesh",
    location: "Bangalore",
    dept: "ITH/IO",
    transport: "Yes",
    registeredStatus: "Yes",
    email: "capgemini.c.vignesh@mercedes-benz.com",
    userId: 15
  },
];
